import './terms.config';
